import FooterButton, { FooterButtonProps } from 'components/app/controllers/Selectors/common/FooterButton';
import React from 'react';
import { strings } from 'resources';

type CreateTeamButtonProps = Omit<FooterButtonProps, 'title'>;

export function CreateTeamButton(props: CreateTeamButtonProps): JSX.Element {
  return <FooterButton title={strings.teamSwitcher.createTeam} {...props} />;
}
